
import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTranslation } from "react-i18next";
import {
  RandomItemGenerationCategoryDescriptions,
  RandomItemGenerationSubTask,
  RandomItemGenerationSubTaskCategories,
  taskInstructions
} from './RandomItemGenerationTypes';

export const RandomItemGenerationTask: React.FC<{ isRecording: boolean, cohort: string, onCategoryChange: (category: string) => void }> = ({ isRecording, cohort, onCategoryChange }) => {
  const { t } = useTranslation(cohort);
  const [categoryDisplayText, setCategoryDisplayText] = useState<string>('');
  const [selectedCategoryKey, setSelectedCategoryKey] = useState<string>('');
  const [selectedSubTask] = useState<RandomItemGenerationSubTask>(() => {
    const subTasks: RandomItemGenerationSubTask[] = ['task1', 'task2'];
    return subTasks[Math.floor(Math.random() * subTasks.length)];
  });
  const [instructionText, setInstructionText] = useState<string>('');

  useEffect(() => {
    // Select instruction and category for the chosen subtask only once on mount
    const foundInstruction = taskInstructions.find(task => task.id === selectedSubTask);
    setInstructionText(foundInstruction?.instructions || '');
  }, [selectedSubTask]);

  useEffect(() => {
    // Update category display and store key only when recording starts
    if (isRecording) {
      const categories = RandomItemGenerationSubTaskCategories[selectedSubTask];
      if (!categories || categories.length === 0) {
        setCategoryDisplayText('');
        setSelectedCategoryKey('');
        return;
      }
      const randomCategory = categories[Math.floor(Math.random() * categories.length)];
      const categoryText = RandomItemGenerationCategoryDescriptions[randomCategory];
      setCategoryDisplayText(t(categoryText));
      setSelectedCategoryKey(randomCategory);
    }
  }, [isRecording]);

  useEffect(() => {
    if (selectedCategoryKey) {
      onCategoryChange(selectedCategoryKey);
    }
  }, [selectedCategoryKey, onCategoryChange]);

  return (
   <>
  <Typography sx={{ mb: 2 }}>{t(instructionText)}</Typography>
    <Typography sx={{ mb: 2 }}>{t('Time limit 1 minutes')}</Typography>
    <Typography sx={{ mb: 2 }}>{t('The selection will appear when you start recording. The recording will automatically stop at the end.')}</Typography>

  {(categoryDisplayText) && (
      <Box
        sx={{
          mb: 3,
          borderRadius: 2,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
          p: 2.5,
          background: 'linear-gradient(90deg, rgba(26, 161, 235, 0.2) 0%, rgba(189, 0, 255, 0.2) 100%)'
        }}
      >
        <Typography
          variant="h3"
          component='div'
          align="center"
          sx={{ padding: 3 }}
          aria-live="polite"
          aria-atomic="true"
        >
          {categoryDisplayText}
        </Typography>
      </Box>
        )}
    </>
  );
};


